<template>
    <div class="account">
        <a-page-header
        style="border: 1px solid rgb(235, 237, 240);background:#fff;padding:16px 32px"
        :breadcrumb="{ props: { routes } }"
        />
        <div class="account-deatil recharge">
            <a-card>
                <a-row>
                    <a-col :span="8">
                        <span>账号余额</span>
                        <p>￥ {{czstatic.money}}</p>
                    </a-col>
                    <a-col :span="8">
                        <span>累计充值</span>
                        <p>￥ {{czstatic.toatalrechart}}</p>
                    </a-col>
                    <a-col :span="8">
                        <span>累计消费</span>
                        <p>￥ {{czstatic.totalcustom}}</p>
                    </a-col>
                </a-row>
            </a-card>

            <a-card style="margin-top:24px">
                 <a-tabs default-active-key="1">
                    <a-tab-pane key="1" tab="充值记录">
                        <a-table
                            :columns="columns"
                            :pagination="pagination"
                            :loading="loading"
                            @change="handleTableChange"
                            :data-source="data"
                            >
                        </a-table>
                    </a-tab-pane>
                    <a-tab-pane key="2" tab="消费记录">
                        <a-table
                            :columns="columns2"
                            :pagination="xfpagination"
                            :loading="loading"
                            @change="xfTableChange"
                            :data-source="xfdata"
                        >
                        </a-table>
                    </a-tab-pane>
                 </a-tabs>
                
            </a-card>
        </div>
    </div>
</template>

<script>

const columns = [
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
  },
  {
    title: '入账时间',
    dataIndex: 'create_time',
    key: 'create_time',
    sorter: (a, b) => a.create_time - b.create_time,
    sortDirections: ['descend', 'ascend'],
  },
  {
    title: '充值方式',
    dataIndex: 'source_str',
    key: 'source_str',
  },
  {
    title: '充值金额(元)',
    key: 'amount',
    dataIndex: 'amount',
  },
  {
    title: '备注',
    key: 'remark',
    dataIndex: 'remark',
    width:'30%'

  }
];

const columns2 = [
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
  },
  {
    title: '消费时间',
    dataIndex: 'create_time',
    key: 'create_time',
    sorter: (a, b) => a.create_time - b.create_time,
    sortDirections: ['descend', 'ascend'],
  },
  {
    title: '消费方式',
    dataIndex: 'source_typestr',
    key: 'source_typestr',
     filters: [
      { text: '点击计费', value: '1' },
      { text: '线索计费', value: '2' },
    ],
    filterMultiple: false,

  },
  {
    title: '消费金额(元)',
    key: 'amount',
    dataIndex: 'amount',
  },
  {
    title: '备注',
    key: 'remark',
    dataIndex: 'remark',
    width:'30%'

  }
];



export default {
    data(){
        return{
            routes: [
                {path:'home/main',breadcrumbName: '首页'},
                {breadcrumbName: '充值明细'},
            ],
            data:"",
            xfdata:"",
            columns,
            columns2,
            pagination: {},
            xfpagination:{},
            loading: false,
            czstatic:""
        }
    },
    mounted(){
        // this.$axios.get('/api/recharge',{
        //     headers: {
        //         "appid": this.appSet.appid,
        //         "appkey": this.appSet.appkey,
        //         "token":localStorage.getItem('token'),
        //     }
        // }).then((res)=>{
        //     if(res.data.code==200){
        //         this.data=res.data.data.lists
        //     }
        // })
        this.fetch()
        this.xffetch()

        // this.$axios.get('/api/consumelog',{
        //     headers: {
        //         "appid": this.appSet.appid,
        //         "appkey": this.appSet.appkey,
        //         "token":localStorage.getItem('token'),
        //     }
        // }).then((res)=>{
        //     if(res.data.code==200){
        //         this.xfdata=res.data.data.lists
        //     }
        // })

        this.$axios.get('/api/rechargestatistic',{
            headers: {
                "appid": this.appSet.appid,
                "appkey": this.appSet.appkey,
                "token":localStorage.getItem('token'),
            }
        }).then((res)=>{
            if(res.data.code==200){
                this.czstatic=res.data.data
            }
        })
    },
    methods:{
        handleTableChange(pagination, filters, sorter) {
            console.log(pagination);
            const pager = { ...this.pagination };
            pager.current = pagination.current;
            this.pagination = pager;
            this.fetch({
                limits: pagination.pageSize,
                page: pagination.current,
                sortField: sorter.field,
                sortOrder: sorter.order,
                ...filters,
            });
        },
        fetch(params = {}) {
            // params=JSON.parse(JSON.stringify(params).replace(/status/g, 'isover'));
            // params.isover=params.isover[0]
         
            this.loading = true;
            this.$axios.get('/api/recharge',{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                },
                params:{
                    limits: 10,
                    ...params,
                }
            }).then((res)=>{
                if(res.data.code==200){
                    const pagination = { ...this.pagination };
                    pagination.total = res.data.data.count;
                    this.data=res.data.data.lists
                    this.loading = false;
                    this.pagination = pagination;
                    // this.pagination = pagination;
                }
            })

        },

        xfTableChange(xfpagination, filters, sorter) {
            const pager = { ...this.xfpagination };
            pager.current = xfpagination.current;
            this.xfpagination = pager;
            this.xffetch({
                limits: xfpagination.pageSize,
                page: xfpagination.current,
                sortField: sorter.field,
                sortOrder: sorter.order,
                ...filters,
            });
        },
        xffetch(params = {}) {
            // params=JSON.parse(JSON.stringify(params).replace(/status/g, 'isover'));
            // params.isover=params.isover[0]
            params=JSON.parse(JSON.stringify(params).replace(/source_typestr/g, 'source_type'));
            if(params.source_type){
                params.source_type=params.source_type[0]
            }
            this.loading = true;
            this.$axios.get('/api/consumelog',{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                },
                params:{
                    limits: 10,
                    ...params,
                }
            }).then((res)=>{
                if(res.data.code==200){
                    const pagination = { ...this.xfpagination };
                    pagination.total = res.data.data.count;
                    this.xfdata=res.data.data.lists
                    this.loading = false;
                    this.xfpagination = pagination;
                    // this.pagination = pagination;
                }
            })

        },

    }
}
</script>




// WEBPACK FOOTER //
// src/components/system/recharge.vue